import React, { useState } from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

import CommunityAdminModal from './CommunityAdminModal';
import { useCommunitiesContext } from '../CommunitiesContext';

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CommunityCreate = () => {
  const { refetch } = useCommunitiesContext();
  const [open, setOpen] = useState(false);

  const handleClose = (refresh = false) => {
    setOpen(false);
    refetch();
  };

  return (
    <>
      {open && <CommunityAdminModal open={open} onClose={handleClose} />}
      <StyledButton
        type={'primary'}
        icon={<img src="/icons/add.svg" height={22} width={22} alt="add" />}
        onClick={() => setOpen(true)}
      >
        Add Community
      </StyledButton>
    </>
  );
};

export default CommunityCreate;
